import Transformer from '../transformer'

export default class typeTransformer extends Transformer {
  static fetch({ codename, description, id, image_resize, is_active, max_size, name}) {
    return {
      codename, 
      description,
      id,
      name,
      imageResize: image_resize,
      isActive: is_active,
      maxSize: max_size
    }
  }
}



// WEBPACK FOOTER //
// ./src/transformers/Files/filetype.js